"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./threadSearch.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Search
} = _input.default;

class ThreadSearch extends _react.Component {
  constructor() {
    super(...arguments);

    this.onChange = event => {
      this.props.search(event.target.value);
    };

    this.onSearch = value => {
      this.props.search(value);
    };
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(Search, {
      allowClear: true,
      value: this.props.searchTerm,
      className: "thread-search-input",
      placeholder: "Search Threads",
      onChange: this.onChange,
      onSearch: this.onSearch,
      bordered: false,
      loading: !!this.props.searchTerm && this.props.loadInboxStatus.isLoading,
      enterButton: true,
      style: {
        padding: '10px 15px 0 15px'
      }
    });
  }

}

const mapStateToProps = state => {
  return {
    loadInboxStatus: selectors.loadMessageInboxStatus(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ThreadSearch);

exports.default = _default;